<template>
  <v-snackbar v-model="toastStatus" :timeout="timeout" class="toast_wrap">
    <i class="icon success_icon"></i>
    <span>{{ content }}</span>
    <template #action="{ attrs }">
      <!--      <v-btn v-if="linkBtn" text v-bind="attrs" @click="$emit('nextPage')">{{ linkBtn }}</v-btn>-->
      <v-btn text v-bind="attrs" @click="toastStatus = false">{{ $t('common.button.confirm') }}</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'Toast',
  data() {
    return {
      toastStatus: false,
      content: '',
      linkBtn: '',
      timeout: 5000,
    };
  },
  methods: {
    show(data) {
      this.content = data.content || this.$i18n.t('message.complete.completion');
      this.linkBtn = data.linkBtn || '';
      this.timeout = data.timeout || 5000;
      this.toastStatus = true;
    },
  },
};
</script>

<style scoped></style>
